// extracted by mini-css-extract-plugin
module.exports = {"diagram_button":"ToggleButton_diagram_button__2iHDl","order_button":"ToggleButton_order_button__3BHqK"};